import "promise-polyfill/src/polyfill";
import objectFitImages from "object-fit-images";
import cartScrollable from "./cart-scrollable";
import cartModal from "./cart-modal";
import cartApp from "./cart-app";
import cartShipping from "./cart-shipping";
import completeInfo from "./cart-complete-info";
import checkoutOverview from "./checkout-overview";
import product from "./product";
import headerShop from "./header-shop";
import headerShopMobile from "./header-shop-mobile";
import filters from "./filters";

objectFitImages(null, { watchMQ: true });
cartScrollable();
cartModal();
cartApp();
completeInfo();
cartShipping();
checkoutOverview();
product();
headerShop();
headerShopMobile();
filters();
